import React, { useState, useContext } from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

import TradeView from "./TradeView";
import FundView from "./FundView";
import WithdrawalQueue from "./WithdrawalQueue";
import UserManagement from "./UserManagement";
import AuditLogs from "./AuditLogs";
import RiskMonitor from "./RiskMonitor";
import InstrumentMaster from "./InstrumentMaster";
import AnalyticsView from "./AnalyticsView";
import SupportTickets from "./SupportTickets";
import MarginManagement from "./MarginManagement";

const AdminDashboard = () => {
  const { user, logout } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("trades");
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div style={containerStyle}>
      {/* Admin Sidebar Navigation */}
      <div style={sidebarStyle}>
        <div style={brandStyle}>
          <div style={badgeStyle}>ADMIN</div>
          <h3 style={{ margin: "4px 0 0", color: "#fff", fontSize: "18px" }}>OpenBull Control</h3>
          <p style={{ margin: "2px 0 0", color: "#888", fontSize: "11px" }}>Paper Trading Console</p>
        </div>

        <nav style={navStyle}>
          <Link
            to="/admin"
            onClick={() => setActiveTab("trades")}
            style={activeTab === "trades" ? activeNavItemStyle : navItemStyle}
          >
            📊 Global Trade View
          </Link>
          <Link
            to="/admin/funds"
            onClick={() => setActiveTab("funds")}
            style={activeTab === "funds" ? activeNavItemStyle : navItemStyle}
          >
            💼 Fund Management
          </Link>
          <Link
            to="/admin/margin"
            onClick={() => setActiveTab("margin")}
            style={activeTab === "margin" ? activeNavItemStyle : navItemStyle}
          >
            ⚖️ Margin Control
          </Link>
          <Link
            to="/admin/withdrawals"
            onClick={() => setActiveTab("withdrawals")}
            style={activeTab === "withdrawals" ? activeNavItemStyle : navItemStyle}
          >
            ⌛ Withdrawal Approvals
          </Link>
          <Link
            to="/admin/users"
            onClick={() => setActiveTab("users")}
            style={activeTab === "users" ? activeNavItemStyle : navItemStyle}
          >
            👥 User & KYC Control
          </Link>
          <Link
            to="/admin/audit-logs"
            onClick={() => setActiveTab("audit")}
            style={activeTab === "audit" ? activeNavItemStyle : navItemStyle}
          >
            🛡️ System Audit Trail
          </Link>
          <Link
            to="/admin/risk"
            onClick={() => setActiveTab("risk")}
            style={activeTab === "risk" ? activeNavItemStyle : navItemStyle}
          >
            ⚠️ Risk & Exposure
          </Link>
          <Link
            to="/admin/instruments"
            onClick={() => setActiveTab("instruments")}
            style={activeTab === "instruments" ? activeNavItemStyle : navItemStyle}
          >
            📈 Stock Master List
          </Link>
          <Link
            to="/admin/analytics"
            onClick={() => setActiveTab("analytics")}
            style={activeTab === "analytics" ? activeNavItemStyle : navItemStyle}
          >
            📉 Analytics & Volume
          </Link>
          <Link
            to="/admin/tickets"
            onClick={() => setActiveTab("tickets")}
            style={activeTab === "tickets" ? activeNavItemStyle : navItemStyle}
          >
            💬 Support Inbox
          </Link>
        </nav>

        <div style={footerStyle}>
          <Link to="/" style={{ color: "#2962ff", textDecoration: "none", fontSize: "12px", display: "block", marginBottom: "8px" }}>
            ← Switch to Client Panel
          </Link>
          <button onClick={handleLogout} style={logoutBtnStyle}>
            Logout Admin ({user?.name || "Admin"})
          </button>
        </div>
      </div>

      {/* Main Admin View Content */}
      <div style={contentStyle}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0, color: "#fff", fontSize: "20px" }}>Admin Command & Control Panel</h2>
          <div style={{ color: "#888", fontSize: "13px" }}>
            LoggedIn: <strong>{user?.email}</strong> | Role: <span style={{ color: "#ef5350", fontWeight: "bold" }}>SUPER ADMIN</span>
          </div>
        </div>

        <div style={bodyStyle}>
          <Routes>
            <Route path="/" element={<TradeView />} />
            <Route path="/funds" element={<FundView />} />
            <Route path="/margin" element={<MarginManagement />} />
            <Route path="/withdrawals" element={<WithdrawalQueue />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/audit-logs" element={<AuditLogs />} />
            <Route path="/risk" element={<RiskMonitor />} />
            <Route path="/instruments" element={<InstrumentMaster />} />
            <Route path="/analytics" element={<AnalyticsView />} />
            <Route path="/tickets" element={<SupportTickets />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const containerStyle = {
  display: "flex",
  minHeight: "100vh",
  backgroundColor: "#131722",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  color: "#d1d4dc",
};

const sidebarStyle = {
  width: "250px",
  backgroundColor: "#1e222d",
  borderRight: "1px solid #2a2e39",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const brandStyle = {
  padding: "20px",
  borderBottom: "1px solid #2a2e39",
};

const badgeStyle = {
  display: "inline-block",
  padding: "2px 8px",
  backgroundColor: "#ef5350",
  color: "#fff",
  borderRadius: "4px",
  fontSize: "10px",
  fontWeight: "bold",
  letterSpacing: "1px",
};

const navStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "12px 0",
  gap: "4px",
};

const navItemStyle = {
  padding: "12px 20px",
  color: "#b2b5be",
  textDecoration: "none",
  fontSize: "13px",
  fontWeight: 500,
  transition: "all 0.2s",
};

const activeNavItemStyle = {
  ...navItemStyle,
  color: "#fff",
  backgroundColor: "#2a2e39",
  borderLeft: "4px solid #ef5350",
};

const footerStyle = {
  padding: "16px 20px",
  borderTop: "1px solid #2a2e39",
};

const logoutBtnStyle = {
  width: "100%",
  padding: "8px",
  backgroundColor: "rgba(239, 83, 80, 0.2)",
  color: "#ef5350",
  border: "1px solid #ef5350",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: "bold",
};

const contentStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
};

const headerStyle = {
  padding: "16px 24px",
  backgroundColor: "#1e222d",
  borderBottom: "1px solid #2a2e39",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const bodyStyle = {
  padding: "24px",
  flex: 1,
};

export default AdminDashboard;
